var Be = Object.defineProperty;
var we = (t, e, n) => e in t ? Be(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var y = (t, e, n) => (we(t, typeof e != "symbol" ? e + "" : e, n), n);
const b = "Asset";
var p = /* @__PURE__ */ ((t) => (t.FIELD_ID = "data-contentful-field-id", t.ENTRY_ID = "data-contentful-entry-id", t.LOCALE = "data-contentful-locale", t))(p || {});
function g(t) {
  return !!(t && typeof t == "object" && "sys" in t && t.sys.id);
}
function re() {
  return [
    ...new Set(
      [...document.querySelectorAll(`[${p.ENTRY_ID}]`)].map((t) => t.getAttribute(p.ENTRY_ID)).filter(Boolean)
    )
  ];
}
let ae = !1;
function W(t) {
  ae = t;
}
const K = (t) => (...e) => {
  ae && console[t](...e);
}, h = {
  error: K("error"),
  warn: K("warn"),
  log: K("log")
}, ve = /* @__PURE__ */ new Set([
  "Symbol",
  "Text",
  "Integer",
  "Number",
  "Boolean",
  "Date",
  "Location",
  "Object"
]);
function G({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: n
}) {
  var s;
  t[n] = ((s = e.fields) == null ? void 0 : s[n]) ?? null;
}
function oe(t) {
  var e;
  return !!(ve.has(t.type) || t.type === "Array" && ((e = t.items) == null ? void 0 : e.type) === "Symbol");
}
const Ke = "2.11.2", q = `current-${p.FIELD_ID}`, F = `current-${p.ENTRY_ID}`, z = `current-${p.LOCALE}`, X = "contentful-tooltip", Me = 32, Ue = 5, R = 10, me = "live-preview-editor", He = "live-preview-sdk", Ge = ["https://app.contentful.com", "https://app.eu.contentful.com"];
function N(t, e) {
  const n = {
    ...e,
    method: t,
    from: "live-preview",
    source: He,
    location: window.location.href,
    version: Ke
  };
  h.log("Send message", n), Ge.forEach((s) => {
    var i;
    (i = window.top) == null || i.postMessage(n, s);
  });
}
function ft(t, e = 100) {
  let n;
  return (...s) => {
    clearTimeout(n), n = setTimeout(() => {
      t.apply(this, s);
    }, e);
  };
}
class ke {
  constructor(e, n) {
    y(this, "storageKey");
    y(this, "value");
    this.storageKey = e, this.value = this.restoreSessionData() || n;
  }
  getKey(e, n) {
    return `${e}-${n}`;
  }
  restoreSessionData() {
    try {
      const e = window.sessionStorage.getItem(this.storageKey), n = e ? JSON.parse(e) : null;
      return Array.isArray(n) ? new Map(n) : null;
    } catch {
      return null;
    }
  }
  get(e, n) {
    return this.value.get(this.getKey(e, n));
  }
  set(e, n, s) {
    this.value.set(this.getKey(e, n), s);
    try {
      window.sessionStorage.setItem(
        this.storageKey,
        JSON.stringify(Array.from(this.value.entries()))
      );
    } catch {
      h.warn(`StorageMap: Failed to set data for key "${e}" in sessionStorage`);
    }
  }
  clear() {
    this.value.clear();
    try {
      window.sessionStorage.removeItem(this.storageKey);
    } catch {
      h.warn("StorageMap: Failed to clear data from sessionStorage");
    }
  }
}
function Ye(t) {
  if (!t)
    return t;
  try {
    const e = new URL(t, "https://images.ctfassets.net");
    return e.protocol = "https:", e.href;
  } catch (e) {
    return h.error(`Recevied invalid asset url "${t}"`, e), t;
  }
}
function k(t) {
  if (typeof structuredClone == "function")
    return structuredClone(t);
  try {
    return JSON.parse(JSON.stringify(t));
  } catch (e) {
    return h.warn("Failed to clone data, updates are done on the original one", t, e), t;
  }
}
function Pe() {
  var t;
  try {
    return ((t = window.top) == null ? void 0 : t.location.href) !== window.location.href;
  } catch {
    return !0;
  }
}
function je() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function $e(t, e = 500) {
  let n = window.location.href;
  const i = setInterval(() => {
    const r = window.location.href;
    r !== n && (n = r, t(r));
  }, e);
  return () => clearInterval(i);
}
function ce(t, e) {
  if (!e.length)
    return t;
  try {
    const [n, ...s] = e;
    return ce(t[n], s);
  } catch {
    return;
  }
}
function J(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
class Ve {
  get entities() {
    return [
      ...this.entitiesMap.values()
    ];
  }
  updateEntity(e) {
    this.entitiesMap.set(e.sys.id, e);
  }
  getValue(e, n) {
    const s = this.entitiesMap.get(e.sys.id);
    if (!s || s.sys.type !== e.sys.linkType) {
      console.warn(`Unresolved entity reference: ${e}`);
      return;
    }
    return ce(s, n);
  }
  getEntitiesFromMap(e) {
    const n = [], s = [];
    for (const i of e) {
      const r = this.entitiesMap.get(i);
      r ? n.push(r) : s.push(i);
    }
    if (s.length)
      throw new Error(`Missing entity in the store (${s.join(",")})`);
    return n;
  }
  async fetchAsset(e) {
    try {
      return this.getEntitiesFromMap([
        e
      ])[0];
    } catch {
      console.warn(`Asset "${e}" is not in the store`);
      return;
    }
  }
  async fetchAssets(e) {
    return this.getEntitiesFromMap(e);
  }
  async fetchEntry(e) {
    try {
      return this.getEntitiesFromMap([
        e
      ])[0];
    } catch {
      console.warn(`Entry "${e}" is not in the store`);
      return;
    }
  }
  async fetchEntries(e) {
    return this.getEntitiesFromMap(e);
  }
  constructor({ entities: e, locale: n }) {
    J(this, "locale", void 0), J(this, "entitiesMap", void 0), this.entitiesMap = new Map(e.map((s) => [
      s.sys.id,
      s
    ])), this.locale = n;
  }
}
function C(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var Z;
(function(t) {
  t.REQUEST_ENTITIES = "REQUEST_ENTITIES", t.REQUESTED_ENTITIES = "REQUESTED_ENTITIES";
})(Z || (Z = {}));
class Qe extends Ve {
  cleanupPromise(e) {
    setTimeout(() => {
      this.requestCache.delete(e);
    }, 300);
  }
  getCacheId(e) {
    return e.length === 1 ? e[0] : e.join(this.cacheIdSeperator);
  }
  findMissingEntites(e) {
    const n = [];
    for (const s of e)
      this.entitiesMap.get(s) || n.push(s);
    return n;
  }
  async fetchEntity(e, n) {
    const s = this.findMissingEntites(e);
    if (s.length === 0)
      return e.map((c) => this.entitiesMap.get(c));
    const i = this.getCacheId(s), r = this.requestCache.get(i);
    if (r)
      return r;
    const o = new Promise((c, l) => {
      const u = this.subscribe("REQUESTED_ENTITIES", (d) => {
        s.every((E) => d.entities.find((L) => L.sys.id === E)) && (clearTimeout(f), c(d.entities), this.cleanupPromise(i), e.forEach((E) => this.cleanupPromise(E)), u());
      }), f = setTimeout(() => {
        l(new Error("Request for entities timed out")), u();
      }, this.timeoutDuration);
      this.sendMessage("REQUEST_ENTITIES", {
        entityIds: s,
        entityType: n ? "Asset" : "Entry",
        locale: this.locale
      });
    });
    return this.requestCache.set(i, o), e.forEach((c) => {
      this.requestCache.set(c, o);
    }), (await o).forEach((c) => {
      this.entitiesMap.set(c.sys.id, c);
    }), e.map((c) => this.entitiesMap.get(c));
  }
  async fetchAsset(e) {
    try {
      return (await this.fetchAssets([
        e
      ]))[0];
    } catch {
      console.warn(`Failed to request asset ${e}`);
      return;
    }
  }
  fetchAssets(e) {
    return this.fetchEntity(e, !0);
  }
  async fetchEntry(e) {
    try {
      return (await this.fetchEntries([
        e
      ]))[0];
    } catch (n) {
      console.warn(`Failed to request entry ${e}`, n);
      return;
    }
  }
  fetchEntries(e) {
    return this.fetchEntity(e);
  }
  constructor({ entities: e, locale: n, sendMessage: s, subscribe: i, timeoutDuration: r = 3e3 }) {
    super({
      entities: e,
      locale: n
    }), C(this, "requestCache", /* @__PURE__ */ new Map()), C(this, "sendMessage", void 0), C(this, "subscribe", void 0), C(this, "timeoutDuration", void 0), C(this, "cacheIdSeperator", ","), this.sendMessage = s, this.subscribe = i, this.timeoutDuration = r;
  }
}
const U = "Collection";
function B(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function Y(t) {
  return `${t}${U}`;
}
function We(t) {
  if (t.endsWith(U))
    return B(t.replace(U, ""));
}
const M = {};
function x(t) {
  return M[t] || (M[t] = new Qe({
    entities: [],
    sendMessage: N,
    subscribe: (e, n) => {
      const s = (i) => {
        typeof i.data != "object" || !i.data || i.data.from === "live-preview" && i.data.method === e && n(i.data);
      };
      return window.addEventListener("message", s), () => window.removeEventListener("message", s);
    },
    locale: t
  })), M[t];
}
async function P({
  entityReferenceMap: t,
  referenceId: e,
  isAsset: n,
  locale: s
}) {
  var o, a, c;
  const i = t.get(e);
  if (i)
    return {
      reference: i,
      typeName: "contentType" in i.sys && ((c = (a = (o = i.sys) == null ? void 0 : o.contentType) == null ? void 0 : a.sys) != null && c.id) ? B(i.sys.contentType.sys.id) : b
    };
  if (n) {
    const l = await x(s).fetchAsset(e);
    if (!l)
      throw new Error(`Unknown reference ${e}`);
    return {
      reference: l,
      typeName: b
    };
  }
  const r = await x(s).fetchEntry(e);
  if (!r)
    throw new Error(`Unknown reference ${e}`);
  return {
    reference: r,
    typeName: B(r.sys.contentType.sys.id)
  };
}
function qe(t) {
  return typeof t.data != "object" || !t.data ? !1 : "from" in t.data && t.data.from === "live-preview" || "source" in t.data && t.data.source === me;
}
var T = /* @__PURE__ */ ((t) => (t.CONNECTED = "CONNECTED", t.DISCONNECTED = "DISCONNECTED", t.ERROR = "ERROR", t.IFRAME_CONNECTED = "IFRAME_CONNECTED", t.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", t.URL_CHANGED = "URL_CHANGED", t.SUBSCRIBED = "SUBSCRIBED", t.ENTRY_UPDATED = "ENTRY_UPDATED", t.ENTRY_SAVED = "ENTRY_SAVED", t.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", t.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", t.ENTITY_NOT_KNOWN = "ENTITY_NOT_KNOWN", t.UNKNOWN_REFERENCE_LOADED = "UNKNOWN_REFERENCE_LOADED", t))(T || {});
function le(t, e, n) {
  N("TAGGED_FIELD_CLICKED", {
    action: "TAGGED_FIELD_CLICKED",
    fieldId: t,
    entryId: e,
    locale: n
  });
}
class Fe {
  constructor({ locale: e }) {
    y(this, "tooltip", null);
    // this tooltip scrolls to the correct field in the entry editor
    y(this, "currentElementBesideTooltip", null);
    // this element helps to position the tooltip
    y(this, "defaultLocale");
    this.tooltip = null, this.currentElementBesideTooltip = null, this.defaultLocale = e, this.updateTooltipPosition = this.updateTooltipPosition.bind(this), this.addTooltipOnHover = this.addTooltipOnHover.bind(this), this.createTooltip = this.createTooltip.bind(this), this.clickHandler = this.clickHandler.bind(this), this.createTooltip(), window.addEventListener("scroll", this.updateTooltipPosition), window.addEventListener("mouseover", this.addTooltipOnHover);
  }
  // Handles incoming messages from Contentful
  receiveMessage(e) {
    ("action" in e && e.action === "INSPECTOR_MODE_CHANGED" || e.method === T.INSPECTOR_MODE_CHANGED) && document.body.classList.toggle(
      "contentful-inspector--active",
      e.isInspectorActive
    );
  }
  // Updates the position of the tooltip
  updateTooltipPosition() {
    var s;
    if (!this.currentElementBesideTooltip || !this.tooltip)
      return !1;
    const e = this.currentElementBesideTooltip.getBoundingClientRect(), n = (s = this.tooltip.parentElement) == null ? void 0 : s.getBoundingClientRect();
    if (e && n) {
      let i = e.top - Me;
      const r = e.left - Ue;
      return i < 0 && (e.top < 0 ? i = e.top : i = 0), this.tooltip.style.top = i + "px", this.tooltip.style.left = r + "px", !0;
    }
    return !1;
  }
  addTooltipOnHover(e) {
    var s, i, r;
    const n = e.composedPath();
    for (const o of n) {
      const a = o;
      if (a.nodeName === "BODY")
        break;
      if (typeof (a == null ? void 0 : a.getAttribute) != "function")
        continue;
      const c = a.getAttribute(p.FIELD_ID), l = a.getAttribute(p.ENTRY_ID), u = a.getAttribute(p.LOCALE) ?? this.defaultLocale;
      if (c && l && u) {
        this.currentElementBesideTooltip = a, this.updateTooltipPosition() && ((s = this.tooltip) == null || s.setAttribute(q, c), (i = this.tooltip) == null || i.setAttribute(F, l), (r = this.tooltip) == null || r.setAttribute(z, u));
        break;
      }
    }
  }
  createTooltip() {
    if (!document.querySelector(`.${X}`)) {
      const e = document.createElement("button");
      e.classList.add(X), e.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5325 2.22242C13.825 2.51492 13.825 2.98742 13.5325 3.27992L12.16 4.65242L9.3475 1.83992L10.72 0.467422C11.0125 0.174922 11.485 0.174922 11.7775 0.467422L13.5325 2.22242ZM0.25 13.7499V10.9374L8.545 2.64243L11.3575 5.45493L3.0625 13.7499H0.25Z" fill="white"/>
      </svg>Edit`, window.document.body.insertAdjacentElement("beforeend", e), e.addEventListener("click", this.clickHandler), this.tooltip = e;
    }
    this.updateTooltipPosition();
  }
  // responsible for handling the event when the user clicks on the edit button in the tooltip
  clickHandler() {
    var i, r, o;
    const e = (i = this.tooltip) == null ? void 0 : i.getAttribute(q), n = (r = this.tooltip) == null ? void 0 : r.getAttribute(F), s = ((o = this.tooltip) == null ? void 0 : o.getAttribute(z)) || this.defaultLocale;
    e && n && s && le(e, n, s);
  }
}
var _ = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function dt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var D = {}, A = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.BLOCKS = void 0, function(e) {
    e.DOCUMENT = "document", e.PARAGRAPH = "paragraph", e.HEADING_1 = "heading-1", e.HEADING_2 = "heading-2", e.HEADING_3 = "heading-3", e.HEADING_4 = "heading-4", e.HEADING_5 = "heading-5", e.HEADING_6 = "heading-6", e.OL_LIST = "ordered-list", e.UL_LIST = "unordered-list", e.LIST_ITEM = "list-item", e.HR = "hr", e.QUOTE = "blockquote", e.EMBEDDED_ENTRY = "embedded-entry-block", e.EMBEDDED_ASSET = "embedded-asset-block", e.EMBEDDED_RESOURCE = "embedded-resource-block", e.TABLE = "table", e.TABLE_ROW = "table-row", e.TABLE_CELL = "table-cell", e.TABLE_HEADER_CELL = "table-header-cell";
  }(t.BLOCKS || (t.BLOCKS = {}));
})(A);
var w = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.INLINES = void 0, function(e) {
    e.HYPERLINK = "hyperlink", e.ENTRY_HYPERLINK = "entry-hyperlink", e.ASSET_HYPERLINK = "asset-hyperlink", e.RESOURCE_HYPERLINK = "resource-hyperlink", e.EMBEDDED_ENTRY = "embedded-entry-inline", e.EMBEDDED_RESOURCE = "embedded-resource-inline";
  }(t.INLINES || (t.INLINES = {}));
})(w);
var v = {};
Object.defineProperty(v, "__esModule", { value: !0 });
var m;
(function(t) {
  t.BOLD = "bold", t.ITALIC = "italic", t.UNDERLINE = "underline", t.CODE = "code", t.SUPERSCRIPT = "superscript", t.SUBSCRIPT = "subscript";
})(m || (m = {}));
v.default = m;
var ue = {};
(function(t) {
  var e = _ && _.__spreadArray || function(a, c, l) {
    if (l || arguments.length === 2)
      for (var u = 0, f = c.length, d; u < f; u++)
        (d || !(u in c)) && (d || (d = Array.prototype.slice.call(c, 0, u)), d[u] = c[u]);
    return a.concat(d || Array.prototype.slice.call(c));
  }, n = _ && _.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  }, s;
  Object.defineProperty(t, "__esModule", { value: !0 }), t.V1_MARKS = t.V1_NODE_TYPES = t.TEXT_CONTAINERS = t.HEADINGS = t.CONTAINERS = t.VOID_BLOCKS = t.TABLE_BLOCKS = t.LIST_ITEM_BLOCKS = t.TOP_LEVEL_BLOCKS = void 0;
  var i = A, r = w, o = n(v);
  t.TOP_LEVEL_BLOCKS = [
    i.BLOCKS.PARAGRAPH,
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6,
    i.BLOCKS.OL_LIST,
    i.BLOCKS.UL_LIST,
    i.BLOCKS.HR,
    i.BLOCKS.QUOTE,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    i.BLOCKS.EMBEDDED_RESOURCE,
    i.BLOCKS.TABLE
  ], t.LIST_ITEM_BLOCKS = [
    i.BLOCKS.PARAGRAPH,
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6,
    i.BLOCKS.OL_LIST,
    i.BLOCKS.UL_LIST,
    i.BLOCKS.HR,
    i.BLOCKS.QUOTE,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    i.BLOCKS.EMBEDDED_RESOURCE
  ], t.TABLE_BLOCKS = [
    i.BLOCKS.TABLE,
    i.BLOCKS.TABLE_ROW,
    i.BLOCKS.TABLE_CELL,
    i.BLOCKS.TABLE_HEADER_CELL
  ], t.VOID_BLOCKS = [
    i.BLOCKS.HR,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    i.BLOCKS.EMBEDDED_RESOURCE
  ], t.CONTAINERS = (s = {}, s[i.BLOCKS.OL_LIST] = [i.BLOCKS.LIST_ITEM], s[i.BLOCKS.UL_LIST] = [i.BLOCKS.LIST_ITEM], s[i.BLOCKS.LIST_ITEM] = t.LIST_ITEM_BLOCKS, s[i.BLOCKS.QUOTE] = [i.BLOCKS.PARAGRAPH], s[i.BLOCKS.TABLE] = [i.BLOCKS.TABLE_ROW], s[i.BLOCKS.TABLE_ROW] = [i.BLOCKS.TABLE_CELL, i.BLOCKS.TABLE_HEADER_CELL], s[i.BLOCKS.TABLE_CELL] = [i.BLOCKS.PARAGRAPH], s[i.BLOCKS.TABLE_HEADER_CELL] = [i.BLOCKS.PARAGRAPH], s), t.HEADINGS = [
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6
  ], t.TEXT_CONTAINERS = e([i.BLOCKS.PARAGRAPH], t.HEADINGS, !0), t.V1_NODE_TYPES = [
    i.BLOCKS.DOCUMENT,
    i.BLOCKS.PARAGRAPH,
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6,
    i.BLOCKS.OL_LIST,
    i.BLOCKS.UL_LIST,
    i.BLOCKS.LIST_ITEM,
    i.BLOCKS.HR,
    i.BLOCKS.QUOTE,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    r.INLINES.HYPERLINK,
    r.INLINES.ENTRY_HYPERLINK,
    r.INLINES.ASSET_HYPERLINK,
    r.INLINES.EMBEDDED_ENTRY,
    "text"
  ], t.V1_MARKS = [o.default.BOLD, o.default.CODE, o.default.ITALIC, o.default.UNDERLINE];
})(ue);
var fe = {};
Object.defineProperty(fe, "__esModule", { value: !0 });
var de = {};
Object.defineProperty(de, "__esModule", { value: !0 });
var j = {};
Object.defineProperty(j, "__esModule", { value: !0 });
var ee = A, ze = {
  nodeType: ee.BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: ee.BLOCKS.PARAGRAPH,
      data: {},
      content: [
        {
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }
      ]
    }
  ]
};
j.default = ze;
var O = {};
Object.defineProperty(O, "__esModule", { value: !0 });
O.isText = O.isBlock = O.isInline = void 0;
var Xe = A, Je = w;
function Ee(t, e) {
  for (var n = 0, s = Object.keys(t); n < s.length; n++) {
    var i = s[n];
    if (e === t[i])
      return !0;
  }
  return !1;
}
function Ze(t) {
  return Ee(Je.INLINES, t.nodeType);
}
O.isInline = Ze;
function xe(t) {
  return Ee(Xe.BLOCKS, t.nodeType);
}
O.isBlock = xe;
function et(t) {
  return t.nodeType === "text";
}
O.isText = et;
(function(t) {
  var e = _ && _.__createBinding || (Object.create ? function(f, d, E, L) {
    L === void 0 && (L = E);
    var I = Object.getOwnPropertyDescriptor(d, E);
    (!I || ("get" in I ? !d.__esModule : I.writable || I.configurable)) && (I = { enumerable: !0, get: function() {
      return d[E];
    } }), Object.defineProperty(f, L, I);
  } : function(f, d, E, L) {
    L === void 0 && (L = E), f[L] = d[E];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(f, d) {
    Object.defineProperty(f, "default", { enumerable: !0, value: d });
  } : function(f, d) {
    f.default = d;
  }), s = _ && _.__exportStar || function(f, d) {
    for (var E in f)
      E !== "default" && !Object.prototype.hasOwnProperty.call(d, E) && e(d, f, E);
  }, i = _ && _.__importStar || function(f) {
    if (f && f.__esModule)
      return f;
    var d = {};
    if (f != null)
      for (var E in f)
        E !== "default" && Object.prototype.hasOwnProperty.call(f, E) && e(d, f, E);
    return n(d, f), d;
  }, r = _ && _.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.helpers = t.EMPTY_DOCUMENT = t.MARKS = t.INLINES = t.BLOCKS = void 0;
  var o = A;
  Object.defineProperty(t, "BLOCKS", { enumerable: !0, get: function() {
    return o.BLOCKS;
  } });
  var a = w;
  Object.defineProperty(t, "INLINES", { enumerable: !0, get: function() {
    return a.INLINES;
  } });
  var c = v;
  Object.defineProperty(t, "MARKS", { enumerable: !0, get: function() {
    return r(c).default;
  } }), s(ue, t), s(fe, t), s(de, t);
  var l = j;
  Object.defineProperty(t, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
    return r(l).default;
  } });
  var u = i(O);
  t.helpers = u;
})(D);
function te(t) {
  return !t || typeof t != "object" || !("sys" in t) ? !1 : t.sys.type !== "ResourceLink";
}
function ie(t) {
  return !t || typeof t != "object" || !("sys" in t) ? !1 : t.sys.type === "ResourceLink";
}
function $(t) {
  if (!t || typeof t != "object")
    return !1;
  const e = t;
  return e.content && e.nodeType === D.BLOCKS.DOCUMENT;
}
const he = [
  D.BLOCKS.EMBEDDED_ENTRY,
  D.BLOCKS.EMBEDDED_ASSET,
  D.INLINES.EMBEDDED_ENTRY,
  D.INLINES.ENTRY_HYPERLINK,
  D.INLINES.ASSET_HYPERLINK
];
function ye(t) {
  return t.sys && "linkType" in t.sys && t.sys.linkType === b;
}
function tt(t, e) {
  return t.name.value === "items" && We(e) || t.name.value;
}
function _e(t, e) {
  var s, i;
  const n = [];
  for (const r of t)
    r.kind === "Field" && (n.push({
      name: r.name.value,
      alias: (s = r.alias) == null ? void 0 : s.value,
      __typename: e
    }), (i = r.selectionSet) != null && i.selections && n.push(
      ..._e(
        r.selectionSet.selections,
        tt(r, e)
      )
    ));
  return n;
}
function it(t) {
  var s;
  const e = [];
  for (const i of t.definitions)
    if (i.kind === "OperationDefinition" || i.kind === "FragmentDefinition") {
      const r = "typeCondition" in i ? i.typeCondition.name.value : (s = i.name) == null ? void 0 : s.value;
      if (!r) {
        h.warn("Could not generate __typename for query definition", i);
        continue;
      }
      for (const o of i.selectionSet.selections)
        o.kind === "Field" && e.push(..._e(i.selectionSet.selections, r));
    }
  const n = /* @__PURE__ */ new Map();
  for (const { __typename: i, alias: r, name: o } of e) {
    const a = n.get(i) || {
      alias: /* @__PURE__ */ new Map(),
      fields: /* @__PURE__ */ new Set()
    };
    a.fields.add(o), r && a.alias.set(o, r), n.set(i, a);
  }
  return n;
}
function pe(t, e, n) {
  if (!n)
    return !0;
  const s = n.get(e);
  return s ? s.fields.has(t) || s.fields.has(Y(t)) : !1;
}
function V(t, e, n) {
  var i;
  const s = (i = n == null ? void 0 : n.get(e)) == null ? void 0 : i.alias;
  if (!s)
    return t;
  for (const r in t) {
    const o = s == null ? void 0 : s.get(r);
    o !== r && (t[o] = t[r]);
  }
  return t;
}
function Te(t, e, n) {
  var s, i;
  try {
    const r = e.fields.file, o = r == null ? void 0 : r.details, a = {
      ...t,
      // GraphQL flattens some information
      // and as the live updates are coming from the CMA, we need to transform them
      title: e.fields.title,
      description: e.fields.description,
      contentType: r == null ? void 0 : r.contentType,
      url: Ye(r == null ? void 0 : r.url),
      // Note: video has no `width` and `height`
      width: (s = o == null ? void 0 : o.image) == null ? void 0 : s.width,
      height: (i = o == null ? void 0 : o.image) == null ? void 0 : i.height
    };
    return V(a, b, n);
  } catch (r) {
    return h.warn("Failed update asset", { dataFromPreviewApp: t, updateFromEntryEditor: e }, r), t;
  }
}
async function nt({
  contentType: t,
  dataFromPreviewApp: e,
  updateFromEntryEditor: n,
  locale: s,
  entityReferenceMap: i,
  gqlParams: r
}) {
  var c;
  if (e.sys.id !== n.sys.id)
    return e;
  const o = k(e), a = B(t.sys.id);
  for (const l of t.fields) {
    const u = l.apiName ?? l.name;
    pe(u, a, r) && (oe(l) ? G({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      name: u
    }) : l.type === "RichText" ? await st({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      entityReferenceMap: i,
      name: u,
      locale: s,
      gqlParams: r
    }) : l.type === "Link" ? await Ne({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      name: u,
      locale: s,
      entityReferenceMap: i,
      gqlParams: r
    }) : l.type === "Array" && ((c = l.items) == null ? void 0 : c.type) === "Link" && await Ce({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      name: u,
      locale: s,
      entityReferenceMap: i,
      gqlParams: r
    }));
  }
  return V(o, a, r);
}
function ne(t) {
  return Object.values(t).every((e) => e.length === 0);
}
async function Le(t, e, n, s, i, r) {
  if (he.includes(t.nodeType)) {
    if (t.data && t.data.target && t.data.target.sys) {
      const o = {
        sys: { ...t.data.target.sys, type: "Link", linkType: t.data.target.sys.type }
      };
      let a;
      if (t.data.target.sys.linkType === "Entry" ? a = await Ie({
        referenceFromPreviewApp: null,
        updatedReference: o,
        entityReferenceMap: s,
        locale: i,
        gqlParams: r
      }) : t.data.target.sys.linkType === "Asset" && (a = await Se({
        referenceFromPreviewApp: null,
        updatedReference: o,
        entityReferenceMap: s,
        locale: i,
        gqlParams: r
      })), a)
        switch (t.nodeType) {
          case D.BLOCKS.EMBEDDED_ENTRY:
            e.block.push(a);
            break;
          case D.BLOCKS.EMBEDDED_ASSET:
            n.block.push(a);
            break;
          case D.INLINES.EMBEDDED_ENTRY:
            e.inline.push(a);
            break;
          case D.INLINES.ENTRY_HYPERLINK:
            e.hyperlink.push(a);
            break;
          case D.INLINES.ASSET_HYPERLINK:
            n.hyperlink.push(a);
            break;
          default:
            h.warn("Unhandled nodeType in embedded entries in rich text", {
              nodeType: t.nodeType,
              ref: a
            });
        }
    }
  } else if (t.content)
    for (const o of t.content)
      await Le(o, e, n, s, i, r);
}
async function De(t, e, n, s) {
  const i = { block: [], inline: [], hyperlink: [] }, r = { block: [], inline: [], hyperlink: [] };
  if (t)
    for (const o of t.content)
      await Le(o, i, r, e, n, s);
  return {
    entries: ne(i) ? { block: [], inline: [], hyperlink: [] } : i,
    assets: ne(r) ? { block: [], inline: [], hyperlink: [] } : r
  };
}
async function st({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: n,
  locale: s,
  entityReferenceMap: i,
  gqlParams: r
}) {
  var o;
  t[n] || (t[n] = {}), t[n].json = ((o = e == null ? void 0 : e.fields) == null ? void 0 : o[n]) || null, t[n].links = await De(
    t[n].json,
    i,
    s,
    r
  );
}
async function Se({
  referenceFromPreviewApp: t,
  updatedReference: e,
  entityReferenceMap: n,
  locale: s,
  gqlParams: i
}) {
  const { reference: r } = await P({
    entityReferenceMap: n,
    referenceId: e.sys.id,
    isAsset: !0,
    locale: s
  });
  return Te(
    {
      ...t,
      ...e,
      __typename: b
    },
    r,
    i
  );
}
async function Ie({
  referenceFromPreviewApp: t,
  updatedReference: e,
  entityReferenceMap: n,
  locale: s,
  gqlParams: i
}) {
  var c;
  const { reference: r, typeName: o } = await P({
    entityReferenceMap: n,
    referenceId: e.sys.id,
    locale: s
  }), a = {
    ...t,
    ...e,
    __typename: o
  };
  for (const l in r.fields) {
    if (!pe(l, o, i))
      continue;
    const u = r.fields[l];
    if (u && typeof u == "object")
      $(u) && (a[l] = { json: u }, a[l].links = await De(u, n, s)), "sys" in u && (a[l] = u, await Ne({
        dataFromPreviewApp: a,
        updateFromEntryEditor: r,
        locale: s,
        entityReferenceMap: n,
        name: l,
        gqlParams: i
      }));
    else if (Array.isArray(u) && ((c = u[0]) != null && c.sys)) {
      const f = Y(l);
      a[f] = { items: u }, await Ce({
        dataFromPreviewApp: a,
        updateFromEntryEditor: r,
        locale: s,
        entityReferenceMap: n,
        name: l,
        gqlParams: i
      });
    } else
      a[l] = u;
  }
  return V(a, o, i);
}
async function Oe({
  referenceFromPreviewApp: t,
  updatedReference: e,
  entityReferenceMap: n,
  locale: s,
  gqlParams: i
}) {
  return e ? t && t.__typename ? t : e.__typename ? e : ye(e) ? Se({
    referenceFromPreviewApp: t,
    updatedReference: e,
    entityReferenceMap: n,
    locale: s,
    gqlParams: i
  }) : Ie({
    referenceFromPreviewApp: t,
    updatedReference: e,
    entityReferenceMap: n,
    locale: s,
    gqlParams: i
  }) : null;
}
async function Ne({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: n,
  locale: s,
  entityReferenceMap: i,
  gqlParams: r
}) {
  var a;
  const o = (a = e == null ? void 0 : e.fields) == null ? void 0 : a[n];
  t[n] = await Oe({
    referenceFromPreviewApp: t[n],
    updatedReference: o,
    entityReferenceMap: i,
    locale: s,
    gqlParams: r
  });
}
async function Ce({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: n,
  locale: s,
  entityReferenceMap: i,
  gqlParams: r
}) {
  var l;
  const o = Y(n), a = ((l = e == null ? void 0 : e.fields) == null ? void 0 : l[n]) || [], c = await Promise.all(
    a.map(async (u) => {
      var E, L;
      const f = (L = (E = t[o]) == null ? void 0 : E.items) == null ? void 0 : L.find((I) => I.sys.id === u.sys.id);
      return await Oe({
        referenceFromPreviewApp: f,
        updatedReference: u,
        entityReferenceMap: i,
        locale: s,
        gqlParams: r
      });
    })
  );
  t[o] || (t[o] = { items: [] }), t[o].items = c.filter(Boolean);
}
function H(t) {
  if (Array.isArray(t)) {
    for (const e of t) {
      const n = H(e);
      if (Object.values(n).includes(!0))
        return n;
    }
    return { isGQL: !1, sysId: null, isREST: !1 };
  } else {
    const e = Object.hasOwn(t, "__typename"), n = Object.hasOwn(t, "sys") ? t.sys.id : null, s = Object.hasOwn(t, "fields");
    return e || n || s ? { isGQL: e, sysId: n, isREST: s } : H(Object.values(t));
  }
}
function rt(t) {
  const { isGQL: e, sysId: n, isREST: s } = H(t);
  return n ? !e && !s ? (h.error(
    'For live updates as a basic requirement the provided data must include the "fields" property for REST or "__typename" for Graphql, otherwise the data will be treated as invalid and live updates are not applied.',
    t
  ), {
    isValid: !1,
    sysId: n,
    isGQL: e,
    isREST: s
  }) : {
    isGQL: e,
    isREST: s,
    sysId: n,
    isValid: !0
  } : (h.error('Live Updates requires the "sys.id" to be present on the provided data', t), {
    isValid: !1,
    sysId: n,
    isGQL: e,
    isREST: s
  });
}
function at(t, e) {
  return t.name === "Asset" ? e.id : e.apiName || e.name;
}
async function Q(t, e, n, s, i, r) {
  let o;
  if (r.has(e.sys.id))
    h.warn("Detected a circular reference, stopping recursion"), o = s.get(
      "urn" in e.sys ? e.sys.urn : e.sys.id
    );
  else {
    r.add(
      "urn" in e.sys ? e.sys.urn : e.sys.id
    );
    const { reference: c } = await P({
      entityReferenceMap: s,
      referenceId: e.sys.id,
      ...ye(e) ? { isAsset: !0 } : void 0,
      locale: n
    });
    o = c;
  }
  if (!o)
    return t;
  const a = k(o);
  for (const c in o.fields) {
    const l = o.fields[c];
    if (te(l) && i < R)
      await Ae(
        a,
        o,
        n,
        c,
        s,
        i + 1,
        r
      );
    else if (Array.isArray(l) && te(l[0]) && i < R)
      await be(
        a,
        o,
        n,
        c,
        s,
        i + 1,
        r
      );
    else if ($(l))
      await Re(
        a,
        o,
        c,
        n,
        s,
        i + 1,
        r
      );
    else {
      if (ie(l) || Array.isArray(l) && ie(l[0]))
        return h.warn("Detected a resource link, support is still under development."), a;
      G({
        dataFromPreviewApp: a.fields,
        updateFromEntryEditor: o,
        name: c
      });
    }
  }
  return a;
}
async function be(t, e, n, s, i, r, o) {
  var a;
  if (!((a = e.fields) != null && a[s])) {
    delete t.fields[s];
    return;
  }
  return t.fields[s] = await Promise.all(
    e.fields[s].map(
      (c, l) => {
        var u;
        return Q(
          (u = t.fields[s]) == null ? void 0 : u[l],
          c,
          n,
          i,
          r + 1,
          o
        );
      }
    )
  ).then((c) => c.filter(Boolean)), t;
}
async function Ae(t, e, n, s, i, r, o) {
  var c;
  const a = (c = e == null ? void 0 : e.fields) == null ? void 0 : c[s];
  if (!a) {
    delete t.fields[s];
    return;
  }
  return t.fields[s] = await Q(
    t.fields[s],
    a,
    n,
    i,
    r + 1,
    o
  ), t;
}
async function ge(t, e, n, s, i) {
  var r;
  if (he.includes(t.nodeType) && t.data && t.data.target && t.data.target.sys && (t.data.target.sys.linkType === "Entry" || t.data.target.sys.linkType === "Asset")) {
    const a = {
      sys: { id: ((r = t.data.target) == null ? void 0 : r.sys.id) || "", type: "Link", linkType: t.data.target.sys.linkType }
    };
    t.data.target = await Q(
      void 0,
      a,
      n,
      e,
      s + 1,
      i
    );
  }
  if (t.content)
    for (const o of t.content)
      await ge(
        o,
        e,
        n,
        s + 1,
        i
      );
}
async function Re(t, e, n, s, i, r, o) {
  var c;
  const a = (c = e.fields) == null ? void 0 : c[n];
  if ($(a)) {
    t.fields[n] = a;
    for (const l of a.content)
      await ge(l, i, s, r, o);
  }
}
async function ot(t, e, n, s, i, r, o) {
  var a;
  if (e.sys.id !== n.sys.id)
    return e;
  for (const c of t.fields) {
    const l = at(t, c);
    if (oe(c) || c.type === "File")
      G({
        dataFromPreviewApp: e.fields,
        updateFromEntryEditor: n,
        name: l
      });
    else if (c.type === "Link" && r < R)
      await Ae(
        e,
        n,
        s,
        l,
        i,
        r + 1,
        o
      );
    else if (c.type === "Array" && ((a = c.items) == null ? void 0 : a.type) === "Link" && r < R)
      await be(
        e,
        n,
        s,
        l,
        i,
        r + 1,
        o
      );
    else if (c.type === "RichText")
      await Re(
        e,
        n,
        l,
        s,
        i,
        r,
        o
      );
    else if (c.type === "ResourceLink")
      return h.warn("Detected a resource link, support is still under development."), e;
  }
  return e;
}
class ct {
  constructor({ locale: e }) {
    y(this, "subscriptions", /* @__PURE__ */ new Map());
    y(this, "storage");
    y(this, "defaultLocale");
    this.defaultLocale = e, this.storage = new ke("live-updates", /* @__PURE__ */ new Map()), window.addEventListener("beforeunload", () => this.clearStorage());
  }
  async mergeEntity({
    contentType: e,
    dataFromPreviewApp: n,
    entityReferenceMap: s,
    locale: i,
    updateFromEntryEditor: r,
    gqlParams: o,
    visitedReferences: a
  }) {
    return "__typename" in n ? {
      data: await (n.__typename === "Asset" ? Te(n, r, o) : nt({
        contentType: e,
        dataFromPreviewApp: n,
        updateFromEntryEditor: r,
        locale: i,
        entityReferenceMap: s,
        gqlParams: o
      })),
      updated: !0
    } : this.isCfEntity(n) ? {
      data: await ot(
        e,
        n,
        r,
        i,
        s,
        0,
        a
      ),
      updated: !0
    } : { updated: !1, data: n };
  }
  /**
   * Merges the `dataFromPreviewApp` together with the `updateFromEntryEditor`
   * If there is not direct match, it will try to merge things together recursively
   * caches the result if cache is enabled and the entity has a `sys.id`.
   * Caching should not be enabled for every entry,
   * because nested references could be merged differently together and this could solve to data loss.
   */
  async mergeNestedReference({ dataFromPreviewApp: e, ...n }, s) {
    const i = g(e) && e.sys.id, r = s && i;
    let o = !1, a = (r ? this.storage.get(i, n.locale) : void 0) || e;
    if (g(a) && i === n.updateFromEntryEditor.sys.id) {
      const c = await this.mergeEntity({ ...n, dataFromPreviewApp: a });
      a = c.data, o = c.updated;
    } else
      for (const c in a)
        if (a[c] && typeof a[c] == "object") {
          const l = await this.merge(
            { ...n, dataFromPreviewApp: a[c] },
            !1
          );
          a[c] = l.data, o = o || l.updated;
        }
    return r && this.storage.set(i, n.locale, a), { data: a, updated: o };
  }
  async merge({ dataFromPreviewApp: e, ...n }, s = !0) {
    if (Array.isArray(e)) {
      const i = [];
      let r = !1;
      for (const o of e) {
        const a = await this.mergeNestedReference(
          { ...n, dataFromPreviewApp: o },
          s
        );
        i.push(a.data), r = r || a.updated;
      }
      return { data: i, updated: r };
    }
    return this.mergeNestedReference({ ...n, dataFromPreviewApp: e }, s);
  }
  isCfEntity(e) {
    return g(e) && "fields" in e;
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(e) {
    if ("action" in e && e.action === "ENTRY_UPDATED" || e.method === T.ENTRY_UPDATED) {
      const { entity: n, contentType: s, entityReferenceMap: i } = e;
      await Promise.all(
        [...this.subscriptions].map(async ([, r]) => {
          try {
            const o = /* @__PURE__ */ new Set(), { updated: a, data: c } = await this.merge({
              // Clone the original data on the top level,
              // to prevent cloning multiple times (time)
              // or modifying the original data (failure potential)
              dataFromPreviewApp: k(r.data),
              locale: r.locale || this.defaultLocale,
              updateFromEntryEditor: n,
              contentType: s,
              entityReferenceMap: i,
              gqlParams: r.gqlParams,
              visitedReferences: o
            });
            a && r.callback(c);
          } catch (o) {
            N(T.ERROR, {
              message: o.message,
              payload: { data: r.data, update: n },
              type: "SUBSCRIPTION_UPDATE_FAILED"
            }), h.error("Failed to apply live update", {
              error: o,
              subscribedData: r.data,
              updateFromEditor: n
            });
          }
        })
      );
    }
  }
  async restore(e, n, s) {
    if (!e)
      return;
    const i = (a) => {
      if (g(a)) {
        const c = this.storage.get(a.sys.id, n);
        if (c)
          return c;
      }
      return a;
    };
    let r;
    if (Array.isArray(e))
      r = e.map(i);
    else {
      const a = i(e);
      a !== e && (r = a);
    }
    const o = this.subscriptions.get(s);
    o && r && o.callback(r);
  }
  clearStorage() {
    this.storage.clear();
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(e) {
    const { isGQL: n, isValid: s, sysId: i, isREST: r } = rt(e.data);
    if (!s)
      return N(T.ERROR, {
        message: "Failed to subscribe",
        payload: { isGQL: n, isValid: s, sysId: i, isREST: r },
        type: "SUBSCRIPTION_SETUP_FAILED"
      }), () => {
      };
    const o = je(), a = e.locale || this.defaultLocale;
    return this.subscriptions.set(o, {
      ...e,
      sysId: i,
      gqlParams: e.query ? it(e.query) : void 0
    }), setTimeout(() => {
      this.restore(e.data, a, o);
    }, 0), N(T.SUBSCRIBED, {
      action: T.SUBSCRIBED,
      type: n ? "GQL" : "REST",
      locale: a,
      entryId: i,
      event: "edit"
    }), () => {
      this.subscriptions.delete(o);
    };
  }
}
class lt {
  constructor({ locale: e }) {
    y(this, "locale");
    y(this, "subscription");
    this.locale = e;
  }
  subscribe(e) {
    return this.subscription && h.log(
      "There is already a subscription for the save event, the existing one will be replaced."
    ), this.subscription = e, () => {
      this.subscription = void 0;
    };
  }
  receiveMessage(e) {
    if (e.method === T.ENTRY_SAVED && this.subscription) {
      const { entity: n } = e;
      re().includes(n.sys.id) && this.subscription(n);
    }
  }
}
const S = class S {
  // Static method to initialize the LivePreview SDK
  static init(e) {
    if (typeof e != "object" || !(e != null && e.locale))
      throw new Error(
        "Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const { debugMode: n, enableInspectorMode: s, enableLiveUpdates: i, locale: r } = e;
    if (typeof window < "u") {
      if (!Pe())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (n && W(n), typeof s == "boolean" && (this.inspectorModeEnabled = s), typeof i == "boolean" && (this.liveUpdatesEnabled = i), this.locale = r, this.initialized)
        return h.log("You have already initialized the Live Preview SDK."), Promise.resolve(S.inspectorMode);
      this.inspectorModeEnabled && (this.inspectorMode = new Fe({ locale: r })), this.liveUpdatesEnabled && (this.liveUpdates = new ct({ locale: r }), this.saveEvent = new lt({ locale: r })), window.addEventListener("message", (a) => {
        var c, l, u;
        if (qe(a)) {
          if (h.log("Received message", a.data), "action" in a.data && a.data.action === "DEBUG_MODE_ENABLED" || a.data.method === T.DEBUG_MODE_ENABLED) {
            W(!0);
            return;
          }
          this.inspectorModeEnabled && ((c = this.inspectorMode) == null || c.receiveMessage(a.data)), this.liveUpdatesEnabled && ((l = this.liveUpdates) == null || l.receiveMessage(a.data), (u = this.saveEvent) == null || u.receiveMessage(a.data));
        }
      }), $e(() => {
        N(T.URL_CHANGED, {
          action: T.URL_CHANGED,
          taggedElementCount: document.querySelectorAll(`[${p.ENTRY_ID}]`).length
        });
      });
      const o = document.querySelectorAll(`[${p.ENTRY_ID}]`).length;
      return N(T.CONNECTED, {
        action: T.CONNECTED,
        connected: !0,
        tags: o,
        taggedElementCount: o,
        locale: this.locale,
        isInspectorEnabled: this.inspectorModeEnabled,
        isLiveUpdatesEnabled: this.liveUpdatesEnabled
      }), this.initialized = !0, Promise.resolve(S.inspectorMode);
    }
  }
  static subscribe(e, n) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    const s = typeof e == "string" ? e : "edit", i = typeof e == "object" ? e : n;
    if (s === "save") {
      if (!this.saveEvent)
        throw new Error(
          "Save event is not initialized, please call `ContentfulLivePreview.init()` first."
        );
      return this.saveEvent.subscribe(i.callback);
    }
    if (!this.liveUpdates)
      throw new Error(
        "Live updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(i);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps({ fieldId: e, entryId: n, locale: s }) {
    return this.inspectorModeEnabled ? !e || !n ? (h.warn("Missing property for inspector mode", { fieldId: e, entryId: n }), null) : {
      [p.FIELD_ID]: e,
      [p.ENTRY_ID]: n,
      [p.LOCALE]: s
    } : null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  static openEntryInEditor({ fieldId: e, entryId: n, locale: s }) {
    (!e || !n) && h.error("Please provide field id and entry id to openEntryInEditor."), le(e, n, s || this.locale);
  }
  /**
   * Returns a list of tagged entries on the page
   */
  static getEntryList() {
    return re();
  }
};
y(S, "initialized", !1), y(S, "inspectorMode", null), y(S, "liveUpdates", null), y(S, "saveEvent", null), y(S, "inspectorModeEnabled", !0), y(S, "liveUpdatesEnabled", !0), y(S, "locale");
let se = S;
export {
  se as C,
  me as L,
  Z as P,
  He as a,
  T as b,
  _ as c,
  ft as d,
  dt as g,
  le as o
};
//# sourceMappingURL=index-5cfde587.js.map
